module.exports = __webpack_public_path__ + "static/media/ic-nav-help.cb78b1b5.svg";